import axios from "axios"
import { getUsuario } from "utils/DatosUsuarioLocalStorag"

/* Tipos de descuento por evento (backend MS-LOGIN-BOLETERIA,
   controller/DescuentosEvento.controller.js + function/descuentos.js).

   Las escrituras (crear/editar/eliminar) exigen perfil admin en el
   backend -> se manda el JWT real ademas del Basic, igual que
   ConfiguracionPagosQuery. */

const BASE = "https://api.t-ickets.com/ms_login/api/v1"

const headersConUsuario = () => ({
    "Content-Type": "application/json",
    "authorization-ticket": "Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ==",
    "Authorization": `Bearer ${getUsuario()}`,
})

/* Vista admin: todos los tipos del evento + usuarios autorizados + usos. */
export const ListarDescuentosEvento = async (codigoEvento) => {
    const { data } = await axios.get(`${BASE}/evento_descuentos`, {
        headers: headersConUsuario(),
        params: { codigoEvento },
    })
    return data
}

/* Vista de venta: solo los ACTIVOS que ese vendedor puede aplicar. */
export const ListarDescuentosVendedor = async (codigoEvento, idOperador) => {
    const { data } = await axios.get(`${BASE}/evento_descuentos`, {
        headers: headersConUsuario(),
        params: { codigoEvento, id_operador: idOperador },
    })
    return data
}

/* Crea (sin id) o actualiza (con id). Campos: nombre, porcentaje,
   mensaje_motivo, activo, fecha_inicio, fecha_fin, max_usos,
   usos_por_cedula, generar_link, quitar_link, usuarios:[admin.id]. */
export const GuardarDescuentoEvento = async (parms) => {
    const { data } = await axios.post(`${BASE}/evento_descuentos`, parms, {
        headers: headersConUsuario(),
    })
    return data
}

export const EliminarDescuentoEvento = async (id) => {
    const { data } = await axios.post(`${BASE}/evento_descuentos/eliminar`, { id }, {
        headers: headersConUsuario(),
    })
    return data
}

/* Guarda el link corto UNA SOLA VEZ por descuento (ver acortarLinkDescuento
   mas abajo). El backend ignora el valor si el descuento ya tenia uno
   guardado y devuelve ese -- nunca lo pisa. */
export const GuardarLinkCortoDescuento = async (id, linkCorto) => {
    const { data } = await axios.post(`${BASE}/evento_descuentos/link_corto`, { id, link_corto: linkCorto }, {
        headers: headersConUsuario(),
    })
    return data
}

/* Reporte de usos de descuentos del evento (detalle por venta + totales). */
export const ReporteDescuentosEvento = async (codigoEvento) => {
    const { data } = await axios.get(`${BASE}/evento_descuentos/reporte`, {
        headers: headersConUsuario(),
        params: { codigoEvento },
    })
    return data
}

// `cedula` es opcional: si se manda, el backend tambien revisa el tope de
// usos por cedula (usos_por_cedula) ademas de vigencia/max_usos.
// `codigoEvento` es opcional: lo manda la casilla "Codigo de descuento" de un evento para que el
// backend rechace un codigo que pertenece a otro evento.
export const InfoDescuentoLink = async (codigo, cedula, codigoEvento) => {
    const params = {}
    if (cedula) params.cedula = String(cedula).trim()
    if (codigoEvento) params.codigoEvento = String(codigoEvento).trim()
    const { data } = await axios.get(`${BASE}/descuento_link/${encodeURIComponent(codigo)}`, {
        headers: headersConUsuario(),
        params: Object.keys(params).length ? params : undefined,
    })
    return data
}

/* Propone un codigo libre (al azar) para el formulario de descuentos. No lo reserva. */
export const GenerarCodigoDescuento = async () => {
    const { data } = await axios.post(`${BASE}/evento_descuentos/generar_codigo`, {}, {
        headers: headersConUsuario(),
    })
    return data
}

/* Link publico que abre el evento en la tienda con el descuento aplicado.
   La tienda (Flasdeticket) ya soporta ?evento=CODIGO + #CODIGO; el
   parametro desc lo consume la Etapa 4. */
export const linkPublicoDescuento = (codigoEvento, codigo) => {
    const origin = typeof window !== "undefined" ? window.location.origin : ""
    return `${origin}/?evento=${encodeURIComponent(codigoEvento)}&desc=${encodeURIComponent(codigo)}#${encodeURIComponent(codigoEvento)}`
}

/* Acortador de links ya existente en cron_speed_ticktes (servicio
   "mikrotiv2", sin relacion con el "mikroti" de flasapi/Boleteria). Se usa
   para el mismo fin en Suscritorid.js (copiar link de un ticket generado).
   No lleva headers de auth -- la ruta /mikrotiv2/api/shorten no los exige.
   OJO: el backend guarda 1 short_id por original_url y lo SOBRESCRIBE si se
   vuelve a pedir el mismo link -- por eso DescuentosPanel.js llama esto SOLO
   UNA VEZ por descuento (cuando codigo_link todavia no tiene link_corto
   guardado en BD) y persiste el resultado con GuardarLinkCortoDescuento;
   nunca se vuelve a pedir para el mismo descuento. */
export const acortarLinkDescuento = async (urlLarga) => {
    try {
        const { data } = await axios.post("https://api.t-ickets.com/mikrotiv2/api/shorten", {
            originalUrl: urlLarga,
        })
        return data?.shortUrl || urlLarga
    } catch (_error) {
        // Best-effort: si el acortador falla, se sigue usando el link largo.
        return urlLarga
    }
}
